import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Vant, {Lazyload} from 'vant'
import './utils/config.js'
import 'amfe-flexible'
import 'vant/lib/index.css'
import '@/assets/icons/iconfont.css'
import '@/styles/sass/i-page/index.scss'
import tool from '@/utils/tools'
import vtoast from '@/utils/vantToast'
import config from '@/utils/config'
import promiseFinally from 'promise.prototype.finally'

// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// let vConsole = new VConsole() // 初始化


promiseFinally.shim()
Vue.use(Vant)
Vue.use(Lazyload)
Vue.prototype.$tool    = tool
Vue.prototype.$vt      = vtoast
Vue.prototype.$co      = config['Audience']
//是否时观众版
Vue.prototype.$isAudience  = config['Audience']['edition'] === "AUDiENCE"
Vue.config.productionTip   = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
